import React, { useRef, useState } from "react";
import styles from './Tooltip.module.scss';
import Icon from "../icon/Icon";
import useClickOutside from "../../hooks/useClickOutside";
import PropTypes from "prop-types";

const Tooltip = ({
  content,
  position = 'right'
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const containerRef = useRef(null);

  useClickOutside(containerRef, () => setShowTooltip(false));

  return (
    <div 
      className={`${styles.container} ${showTooltip ? styles.active : ''}`}
      onClick={() => setShowTooltip(!showTooltip)}
      ref={containerRef}
    >
      <Icon name="info" />
      <div className={`${styles.tooltip} ${position && styles[position] ? styles[position] : ''}`}>
        {content}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  content: PropTypes.any.isRequired,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
}

export default Tooltip;